import { DisplayH2 } from '@components/Text/HeadingTagDisplay.style';
import { PaddingDTM, ParagraphColor, Spacing, SpacingDTM } from '@pages/CommonStyle/common.style';
import { DivAllCenter } from '@pages/CommonStyle/commonDiv.style';
import React from 'react';
import { Trans } from 'react-i18next';
import { ScreenshotLayout } from './Screenshot.style';
import rtls from '@src/lang/ko/main/rtls/rtls';
import { useSelector } from 'react-redux';
import { CommonState } from '@redux/reducers/commonReducer';
import { StyledGridContainer } from '@components/Grid/Grid.style';
import camera from '@src/lang/ko/main/camera/camera';
import sensor from '@src/lang/ko/main/iot/sensor';

interface ScreenshotProps {
  tag: string;
}

export const langMap: Record<string, any> = {
  rtls,
  camera,
  sensor,
};

const Screenshot = ({ tag }: ScreenshotProps): React.ReactElement => {
  const layoutType = useSelector((state: CommonState) => state.gridLayoutType);

  const screenShotData = langMap?.[tag] ?? [];
  return (
    <>
      <StyledGridContainer>
        {screenShotData.screenShot.map((product, index) => (
          <>
            <SpacingDTM d="128" t="96" m="64" />

            <DivAllCenter>
              <DisplayH2 size="small">
                <Trans i18nKey={`${tag}.screenShot.${index}.title`} />
              </DisplayH2>
              <Spacing pixel="16" />
              <ParagraphColor color="#000" size="medium">
                <Trans i18nKey={`${tag}.screenShot.${index}.desc`} />
              </ParagraphColor>
              <Spacing pixel="48" />

              <ScreenshotLayout img={product.img[layoutType]} />
            </DivAllCenter>

            <PaddingDTM d="64" t="64" m="32" />
          </>
        ))}
      </StyledGridContainer>
    </>
  );
};

export default Screenshot;
